import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./CardSlider.css";

const CardSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const cards = [
    {
      id: 1,
      title: (<>Athletes lined up for a race, <br/>1994</>),      
      content: "Source: Heritage centre, IIT Madras",
      image: "assets/sliderimages/slide1.png",
    },
    {
      id: 2,
      title: (<>Athletes lined up for a race, <br/>1994</>),
      content: "Source: Heritage centre, IIT Madras",
      image: "assets/sliderimages/slide2.png",
    },
    {
      id: 3,
      title: "Aerospace Engineering(B.Tech.) students visit IIT Kanpur for a course, 1994",
      content: "Source: Heritage centre, IIT Madras",
      image: "assets/sliderimages/slide3.png",
    },
    {
      id: 4,
      title: "The hosting team IIT Madras at the 30th Inter-IIT Sports Meet, 1994",
      content: "Source: Heritage centre, IIT Madras",
      image: "assets/sliderimages/slide4.png",
    },
    {
      id: 5,
      title: "A basketball battle at the Open Air Theatre, 1994",
      content: "Source: Heritage centre, IIT Madras",
      image: "assets/sliderimages/slide5.png",
    },
    {
      id: 6,
      title: "Ramesh Krishnan addresses the audience at IIT Madras, 1994",
      content: "Source: Heritage centre, IIT Madras",
      image: "assets/sliderimages/slide6.png",
    },
    {
      id: 7,
      title: "A photograph taken during a volleyball match, 1994",
      content: "Source: Heritage centre, IIT Madras",
      image: "assets/sliderimages/slide7.png",
    },
    {
      id: 8,
      title: (<>A football match in progress, <br/>1994</>),
      content: "Source: Heritage centre, IIT Madras",
      image: "assets/sliderimages/slide8.png",
    },
    {
      id: 9,
      title: (<>The gun is fired, <br/>1994</>),
      content: "Source: Heritage centre, IIT Madras",
      image: "assets/sliderimages/slide9.png",
    }
  ];

  return (
    <>
    <div id="memorylane">
    <p className="memory-down">Down the Memory Lane</p>
    </div>
    <div className="carousel-container" >
      <div className="cardcontainer">        
      <Slider {...settings}>
        {cards.map((card) => (
          <div key={card.id} className="card">
            <img src={card.image} alt={card.title} className="card-image" />
            <div className="card-content">
              <h3>{card.title}</h3>
              <p>{card.content}</p>
            </div>
          </div>
        ))}
      </Slider>
      </div>
    </div>
    </>
  );
};
export default CardSlider;